import axiosProxy from '@/api/setting';

export function getUserMe() {
  return axiosProxy({
    url: '/app/users/me',
    method: 'get'
  })
}
export function editUserMe(data) {
  return axiosProxy({
    url: '/app/users/me',
    method: 'patch',
    data
  })
}

export function deleteUserMe() {
  return axiosProxy({
    url: '/app/users/me',
    method: 'delete',
  })
}